import styled, { css } from "styled-components";

import { mixins } from "@similarweb/styles";
import { Text } from "@similarweb/ui-components/foundations";

const truncatedTextStyles = css`
    display: block;
    ${mixins.truncateText()};
`;
const truncatedMultilineTextStyles = css`
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const StyledTruncatedText = styled(Text)<{ lineClamp: number }>`
    ${({ lineClamp }) => (lineClamp > 1 ? truncatedMultilineTextStyles : truncatedTextStyles)}
`;

export const StyledTruncatedTextLabel = styled.span<{ lineClamp: number }>`
    ${({ lineClamp }) => (lineClamp > 1 ? truncatedMultilineTextStyles : truncatedTextStyles)}

    display: ${({ lineClamp }) => (lineClamp > 1 ? "-webkit-box" : "block")};

    /* stylelint-disable-next-line property-no-deprecated -- required alongside -webkit-line-clamp for the multi-line truncation hack; no standard replacement exists */
    -webkit-box-orient: ${({ lineClamp }) => (lineClamp > 1 ? "vertical" : "horizontal")};
    -webkit-line-clamp: ${({ lineClamp }) => lineClamp};
`;
